import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getSearchPathWithRequest } from '../../features/request/helpers';
import { Grid } from '../../utils/grid/Grid';
import Toggle from '../../utils/Toggle';
import Fa from '../../utils/Fa';
import BreakpointHelper from '../../utils/BreakpointHelper';
import TabNavigationList from './components/TabNavigationList';
import TabNavigationContent from './components/TabNavigationContent';

import './tab-navigation.css';

export default class TabNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: props.tabList.length - 1,
    };
    this.navRefs = {};
    this.handleOnTabClick = this.handleOnTabClick.bind(this);
  }

  componentDidUpdate() {
    if (this.toScrollIntoView) {
      const headerRef = document.getElementById('content-header');
      if (!headerRef) return;
      const headerRect = headerRef.getBoundingClientRect();
      const { index, prevRect } = this.toScrollIntoView;
      const currentRect = this.navRefs[index].getBoundingClientRect();
      if (currentRect.top < headerRect.height) {
        // Tab is outside of view
        window.scrollBy(0, currentRect.top - prevRect.top);
      }
      delete this.toScrollIntoView;
    }
  }

  setNavRef(index) {
    return (el) => {
      this.navRefs[index] = el;
    };
  }

  isCurrentTab(index) {
    return this.state.currentTab === index;
  }

  handleOnTabClick(e) {
    if (e.currentTarget && e.currentTarget.dataset) {
      const index = Number(e.currentTarget.dataset.index);
      const currentTab = this.isCurrentTab(index) && BreakpointHelper.matches('xs') ? -1 : index;
      this.setState({ currentTab });
      this.scrollIntoView(currentTab);
    }
  }

  scrollIntoView(index) {
    if (index >= 0 && this.navRefs[index]) {
      this.toScrollIntoView = {
        index,
        prevRect: this.navRefs[index].getBoundingClientRect(),
      };
    }
  }

  renderTabContent(index) {
    if (index >= 0 && this.isCurrentTab(index)) {
      return (
        <div className="tab-content">
          <TabNavigationContent link={getSearchPathWithRequest()} {...this.props.tabList[index]} />
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="tab-navigation">
        <Toggle hide="xs sm">
          <nav className="tab-navigation-nav">
            <Grid>
              <ul className="tab-navigation-nav-list">
                {this.props.tabList.map((tab, index) => (
                  <TabNavigationList
                    currentTab={this.state.currentTab}
                    key={tab.id}
                    data-index={index}
                    onClick={this.handleOnTabClick}
                    isCurrent={this.state.currentTab === index}
                    {...tab}
                  />
                ))}
              </ul>
            </Grid>
          </nav>
          <Grid>{this.renderTabContent(this.state.currentTab)}</Grid>
        </Toggle>
        <Toggle show="xs sm">
          {this.props.tabList.map((tab, index) => (
            <div key={index} className="tab-navigation-nav-item" ref={this.setNavRef(index)}>
              <a
                tabIndex={index}
                className={`tab-navigation-nav-link ${this.isCurrentTab(index) ? 'current' : ''}`}
                data-index={index}
                onClick={this.handleOnTabClick}
              >
                {tab.name}
                <Fa icon={this.isCurrentTab(index) ? 'chevron-up' : 'chevron-down'} />
              </a>
              {this.renderTabContent(index)}
            </div>
          ))}
        </Toggle>
      </div>
    );
  }
}

TabNavigation.propTypes = {
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      text: PropTypes.string,
      hosts: PropTypes.array,
    }),
  ).isRequired,
};
